<template>
  <div>缺少许可</div>
</template>

<script>
export default {

}
</script>
